import React, { useEffect, useMemo, useRef, useState } from "react";
import OrbitEllipse from "../component/OrbitEllipse";
import { da } from "date-fns/locale";
import TestimonialCard from "../component/TestimonialCard";
import { TfiArrowCircleRight } from "react-icons/tfi";
import { TfiArrowCircleLeft } from "react-icons/tfi";

const AboutUs = () => {
  const testimonials = [
    {
      id: 1,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Madhan Sr",
      text: `I had a wonderful stay at this hotel — the rooms were clean, comfortable, and well-maintained.
The staff were polite, helpful, and always smiling, making me feel truly welcome.
The food was delicious with plenty of variety, and the service was quick and professional.
The location was convenient and peaceful, perfect for both relaxation and travel.
Overall, an excellent experience — I’d highly recommend this hotel and would love to stay again.`,

      icon: "/assets/ava.svg",
    },
    {
      id: 2,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Lachu",
      text: `My stay was truly wonderful! The staff were incredibly professional, and the services, food, and cleanliness were all top-notch.
One side of the accommodation was beautifully surrounded by nature, adding to the overall experience.
We thoroughly enjoyed our stay and had a very good experience overall.`,

      icon: "/assets/ava.svg",
    },
    {
      id: 3,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Krishna Khandige",
      text: `We stay at this hotel as we come in from Bangalore on work and the hotel is great. The rooms are sparkling clean and service is great too. We met owner and Managing Director of the hotel who is always hands onat the hotel and an extremely humble person. I would highly recommend anyone travelling past Ranipet to make a stop here. Huge plus point is their 24hr check in policy so you don’t have to worry about missing your check in time.`,

      icon: "/assets/ava.svg",
    },

    {
      id: 4,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Vishnu Vardhan Shekar",
      text: `I had a wonderful experience at this hotel! Right from the moment I arrived, the staff made me feel welcome and taken care of. The rooms were clean, comfortable, and thoughtfully designed — perfect for relaxing after a long day.
What really stood out was the attention to detail and the personal touches that made the stay feel special. Whether it was the friendly service, the peaceful ambiance, or just how everything was run smoothly, you could tell the team really cares about the guest experience.
If you’re looking for a place that feels more like a warm retreat than just a hotel stay, I highly recommend this one. Will definitely be back!`,
      icon: "/assets/ava.svg",
    },

    {
      id: 5,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Vaibhav Shukla",
      text: `Thank you to the HOTEL SASTHAGRAND for providing such a wonderful experience. The combination of the upgraded room, the beautiful confluence of modern and traditional ambience, and the exceptional service made my stay truly remarkable. I will certainly recommend your hotel and look forward to staying with you again in the future.`,
      icon: "/assets/ava.svg",
    },
    {
      id: 6,
      star: "/assets/star-1.svg",
      image: "/assets/goo.svg",
      name: "Jagan Jay",
      text: `stayed 4 nights here… neet and clean rooms are big and confortable …. Food are good …. Staff are polite and helpful…. Highly recommended in arcot`,
      icon: "/assets/ava.svg",
    },
  ];

  const orbitAvatars = [
    "/assets/ava-2.png",
    "/assets/ava-3.png",
    "/assets/ava-4.png",
    "/assets/ava-5.png",
    "/assets/ava-6.png",
    "/assets/ava-7.png",
  ];

  const brandIcon = [
    { id: 1, img: "/assets/gobilo.svg" },
    { id: 1, img: "/assets/makeMyTrip.svg" },
    { id: 1, img: "/assets/adogo.svg" },
    { id: 1, img: "/assets/booking-icon.svg" },
  ];

  const sasthaGrand = [
    {
      id: 1,
      icon: "/assets/flexibility.svg",
      title: "No hidden fees",
      content: "Transparent pricing with no hidden fees.",
    },
    {
      id: 2,
      icon: "/assets/booke-1.svg",
      title: "Instant booking",
      content: "Get confirmation right after you reserve.",
    },
    {
      id: 3,
      icon: "/assets/flexible.svg",
      title: "Flexibility",
      content: "Flexible options with free cancellation on many listings.",
    },
  ];

  const [active, setActive] = useState(0);

  useEffect(() => {
    const total = orbitAvatars.length;
    const rotationDuration = 40000;

    const stepTime = rotationDuration / total;

    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, stepTime);

    return () => clearInterval(interval);
  }, []);

  const VISIBLE_CARDS = 3;
  const [currentIndex, setCurrentIndex] = useState(0);

  const [perView, setPerView] = useState(3);
  const [index, setIndex] = useState(0);
  const [expandedId, setExpandedId] = useState(null);
  const cardRef = useRef(null);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [buttonPos, setButtonPos] = useState({ x: 0, y: 0 });

  const requestRef = useRef();

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 640) setPerView(1);
      else if (w < 1024) setPerView(2);
      else setPerView(3);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const maxIndex = useMemo(() => {
    return Math.max(0, testimonials.length - perView);
  }, [testimonials.length, perView]);

  const atStart = index === 0;
  const atEnd = index === maxIndex;

  const nextSlide = () => setIndex((prev) => Math.min(prev + 1, maxIndex));
  const prevSlide = () => setIndex((prev) => Math.max(prev - 1, 0));

  const translate = `-${index * (100 / perView)}%`;

  const makeBullets = (tes) => {
    return [tes.text1, tes.text2, tes.text3]
      .filter(Boolean)
      .flatMap((t) =>
        String(t)
          .split("\n")
          .map((s) => s.trim()),
      )
      .filter(Boolean);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        expandedId &&
        cardRef.current &&
        !cardRef.current.contains(event.target)
      ) {
        setExpandedId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expandedId]);

  const animate = () => {
    setButtonPos((prev) => ({
      x: prev.x + (cursorPos.x - prev.x) * 0.15, // adjust 0.15 for speed
      y: prev.y + (cursorPos.y - prev.y) * 0.15,
    }));
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [cursorPos]);

  return (
    <section className="w-full bg-[#FFFEF2] px-4 md:px-28 py-14">
      <div className=" flex justify-center items-center ">
        <h2 className=" text-primary font-calson text-[30px] md:text-[64px] font-medium">
          Why Sastha Grand
        </h2>
      </div>

      <div className=" w-full  mt-10  ">
        <div className="relative flex flex-col justify-between md:flex-row  md:gap-0  gap-10  ">
          {sasthaGrand.map((sas, i) => (
            <div key={i} className="relative text-center  z-10">
              {i !== sasthaGrand.length - 1 && (
                <div className=" hidden  md:block absolute w-[130px]  h-[50px] md:w-[300px] md:h-[83px] left-60 top-10  ">
                  <img src="/assets/vecotr-1.svg" />
                </div>
              )}

              <div className="mx-auto w-16 h-16 md:w-[100px] md:h-[100px] bg-[#D9E3EC] rounded-3xl flex items-center justify-center sm:mb-8 ">
                <img
                  src={sas.icon}
                  alt=""
                  className=" w-[30px] h-[30px] md:w-[46px] md:h-[46px]"
                />
              </div>

              <h4 className=" text-[14px]  md:text-[20px]  font-creto font-medium mb-2">
                {sas.title}
              </h4>
              <div className=" md:w-[264px] md:h-[48px]">
                <p className="text-[12px] md:text-[16px] text-gray-600 font-creto  font-normal leading-relaxed px-2 sm:px-0">
                  {sas.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <section className="w-full rounded-md mt-10 relative">
        <h2 className="text-center font-calson font-medium text-[40px] sm:text-[56px] md:text-[64px] text-primary">
          Testimonial
        </h2>

        <div className="mx-auto px-4 sm:px-6 py-10 sm:py-12 max-w-7xl relative">
          {/* ✅ Arrows (Responsive positioning) */}
          <div className="">
            <button
              onClick={prevSlide}
              disabled={atStart}
              className={`absolute -left-2 md:-left-10 top-1/2 -translate-y-1/2 z-10
              w-11 h-11 rounded-full grid place-items-center
              transition
              ${atStart ? "text-primary" : "text-primary hover:text-white"}
              ${atStart ? "opacity-40 cursor-not-allowed" : "hover:bg-primary"}
            `}
            >
              <TfiArrowCircleLeft className={`text-[28px] `} />
            </button>

            <button
              onClick={nextSlide}
              disabled={atEnd}
              className={`absolute -right-2 md:-right-10 top-1/2 -translate-y-1/2  z-10
              w-11 h-11 rounded-full grid place-items-center text-primary hover:text-white
              transition
              ${atEnd ? "opacity-40 cursor-not-allowed" : "hover:bg-primary"}
            `}
            >
              <TfiArrowCircleRight className="text-[28px] " />
            </button>
          </div>

          {/* ✅ Slider */}
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out py-10"
              style={{ transform: `translateX(${translate})` }}
            >
              {testimonials.map((tes) => {
                const isExpanded = expandedId === tes.id;
                const isDimmed = expandedId && expandedId !== tes.id;

                return (
                  <div
                    key={tes.id}
                    className={`shrink-0 px-2 sm:px-3 transition ${
                      isDimmed
                        ? "opacity-30 pointer-events-none"
                        : "opacity-100"
                    }`}
                    style={{ width: `${100 / perView}%` }}
                  >
                    <div
                      ref={isExpanded ? cardRef : null}
                      onMouseMove={(e) => {
                        if (!isExpanded) {
                          const rect = e.currentTarget.getBoundingClientRect();
                          setCursorPos({
                            x: e.clientX - rect.left,
                            y: e.clientY - rect.top,
                          });
                        }
                      }}
                      onClick={() => {
                        if (isExpanded) {
                          setExpandedId(null);
                        }
                      }}
                      className={`group relative  border-[#D4C194] border-[1px] rounded-3xl bg-[#F8F4ED]
                  p-4 sm:p-5 transition-all duration-300
                  w-full ${isExpanded ? "h-auto shadow-2xl z-50 " : "h-[260px] hover:shadow-lg"}`}
                    >
                      {/* Top */}
                      <div className="flex justify-between items-start">
                        <div className="flex gap-3 items-center">
                          <img
                            src={tes.icon}
                            className="w-10 h-10 sm:w-12 sm:h-12"
                            alt=""
                          />
                          <div>
                            <h2 className="font-creto font-medium text-primary text-[16px] sm:text-[18px] leading-5">
                              {tes.name}
                            </h2>
                            <img
                              src={tes.star}
                              className="mt-1 w-20 sm:w-auto"
                              alt=""
                            />
                          </div>
                        </div>
                        <img
                          src={tes.image}
                          className="w-5 h-5 sm:w-6 sm:h-6"
                          alt=""
                        />
                      </div>

                      {/* Text */}
                      <p
                        className={`mt-4 text-[#45443F] transition-all duration-300 text-[14px]  font-normal font-micro   ${
                          isExpanded ? "line-clamp-none" : "line-clamp-6"
                        }`}
                      >
                        {tes.text}
                      </p>

                      {!isExpanded && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            setExpandedId(tes.id);
                          }}
                          style={{
                            left: buttonPos.x - 40,
                            top: buttonPos.y - 40,
                          }}
                          className="
                      absolute
                      w-[80px] h-[80px]
                      rounded-full
                      border border-primary
                      bg-white/90 
                      text-primary text-[13px]
                      flex items-center justify-center
                      opacity-0 group-hover:opacity-100
                    
                    "
                        >
                          View more
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </section>
      <div className=" ">
        <h1 className=" font-calson font-medium text-[30px] md:text-[64px] text-primary flex justify-center items-center">
          We are also Available in
        </h1>
        <div className="flex flex-wrap justify-center mt-10  md:gap-10 gap-y-6">
          {brandIcon.map((bra, i) => {
            const isLast = i === brandIcon.length - 1;

            return (
              <div
                key={i}
                className={`
          flex items-center justify-center
          px-4 sm:px-6
          w-[140px] md:w-[180px]
          h-[44px] sm:h-[54px]
          ${!isLast ? "md:border-r md:border-primary" : ""}
        `}
              >
                <img
                  src={bra.img}
                  alt="brand"
                  className="w-full h-auto object-contain"
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
